import {
  AgentBioUpdateDto,
  AgentCommercialUpdateDto,
  AgentContactInfosUpdateDto,
  AgentNetworkUpdateDto,
  AgentNotificationsUpdateDto,
  AgentOfficeHoursUpdateDto,
  AgentPreferredCitiesUpdateDto,
  AgentProfileDto,
  AgentProfileId,
  AgentSocialLinksUpdateDto,
  AgentSpecialtiesUpdateDto,
  AgentVisibilityUpdateDto,
  AgentZonesUpdateDto,
  EtxeApiSlugs,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../api-caller.service';
import { ApiConnector } from '../../../../api-connector.abstract-service';

export class AgentConnector extends ApiConnector<AgentProfileDto, AgentProfileDto, AgentProfileId> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, EtxeApiSlugs.AGENT);
  }

  patchNetwork(dto: AgentNetworkUpdateDto): Observable<AgentProfileDto> {
    return this.apiCaller.patchRequest<AgentProfileDto>(this.apiPrefix, `${this.slug}/network`, dto);
  }

  patchSpecialties(dto: AgentSpecialtiesUpdateDto): Observable<AgentProfileDto> {
    return this.apiCaller.patchRequest<AgentProfileDto>(this.apiPrefix, `${this.slug}/specialties`, dto);
  }

  patchZones(dto: AgentZonesUpdateDto): Observable<AgentProfileDto> {
    return this.apiCaller.patchRequest<AgentProfileDto>(this.apiPrefix, `${this.slug}/zones`, dto);
  }

  patchCities(dto: AgentPreferredCitiesUpdateDto): Observable<AgentProfileDto> {
    return this.apiCaller.patchRequest<AgentProfileDto>(this.apiPrefix, `${this.slug}/cities`, dto);
  }

  patchBio(dto: AgentBioUpdateDto): Observable<AgentProfileDto> {
    return this.apiCaller.patchRequest<AgentProfileDto>(this.apiPrefix, `${this.slug}/bio`, dto);
  }

  patchCommercial(dto: AgentCommercialUpdateDto): Observable<AgentProfileDto> {
    return this.apiCaller.patchRequest<AgentProfileDto>(this.apiPrefix, `${this.slug}/commercial`, dto);
  }

  patchSocialLinks(dto: AgentSocialLinksUpdateDto): Observable<AgentProfileDto> {
    return this.apiCaller.patchRequest<AgentProfileDto>(this.apiPrefix, `${this.slug}/social-links`, dto);
  }

  patchOfficeHours(dto: AgentOfficeHoursUpdateDto): Observable<AgentProfileDto> {
    return this.apiCaller.patchRequest<AgentProfileDto>(this.apiPrefix, `${this.slug}/office-hours`, dto);
  }

  patchVisibility(dto: AgentVisibilityUpdateDto): Observable<AgentProfileDto> {
    return this.apiCaller.patchRequest<AgentProfileDto>(this.apiPrefix, `${this.slug}/visibility`, dto);
  }

  patchNotifications(dto: AgentNotificationsUpdateDto): Observable<AgentProfileDto> {
    return this.apiCaller.patchRequest<AgentProfileDto>(this.apiPrefix, `${this.slug}/notifications`, dto);
  }

  patchContactInfos(dto: AgentContactInfosUpdateDto): Observable<AgentProfileDto> {
    return this.apiCaller.patchRequest<AgentProfileDto>(this.apiPrefix, `${this.slug}/contact-infos`, dto);
  }
}
